<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer005">
<p class="firstcenter">To Timothy J. Wengert, our teacher</p>
<p class="center"><span class="pagebreak" id="pageviii" title="viii"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?f9d0d536